"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var SummaryTable = function SummaryTable(props) {
  var data = props.data;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].tableWrapper
  }, /*#__PURE__*/_react["default"].createElement("table", {
    className: 'table table-condensed ' + _style["default"].table
  }, /*#__PURE__*/_react["default"].createElement("thead", null, /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("th", null, "Summary"), /*#__PURE__*/_react["default"].createElement("th", {
    className: "text-center"
  }, "Value"))), /*#__PURE__*/_react["default"].createElement("tbody", null, data.map(function (row) {
    return /*#__PURE__*/_react["default"].createElement("tr", {
      key: row.label
    }, /*#__PURE__*/_react["default"].createElement("td", null, row.label.toUpperCase()), /*#__PURE__*/_react["default"].createElement("td", {
      className: "text-center"
    }, row.value));
  }))));
};
SummaryTable.propTypes = {
  data: _propTypes["default"].array
};
var _default = exports["default"] = SummaryTable;